import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../helpers";
import AuthCodePopup from "./authCodePopup";

const Econsent = (props) => {
  const [openAuthCodePopup, setOpenAuthCodePopup] = React.useState(false);

  useEffect(() => {
   handleAuthCodePopup();
  }, []);

  const handleAuthCodePopup = () => {
    setOpenAuthCodePopup(!openAuthCodePopup);
  };
  return (
    <>
      <div style={{ height: 20 }}>
        <script src="https://widget.ellieservices.com/latest/launcher.js"></script>
        <div
          className="em-widget"
          data-width="100%"
          data-height="800px"
          data-min-height="800px"
          data-site-id={process.env.REACT_APP_CC_WIDGET_ID}
          data-config='{"externalLoginWindow":"true"}'
          data-name="ecc-borrower-portal"
          data-aria-label="Borrower Portal"
        ></div>
      </div>
      {
        props.getLoanDataWithIdRes?.data?.authCode && (
          <AuthCodePopup
            openAuthCodePopup={openAuthCodePopup}
            handleAuthCodePopup={handleAuthCodePopup}
            authCode={props.getLoanDataWithIdRes?.data?.authCode}
          />
        )
      }
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Econsent);
// export { Econsent };
